import styled from "styled-components";
import ConfirmRequestAccordion from "./ConfirmRequestAccordion";
import { Colors, TextFont } from "../../config";

const ConfirmRequestTravellerDetailsContainer = ({
  passengers,
  guests,
  formData,
  extraFields,
}) => {
  return (
    <TravellerDetailsContainer>
      <ColumnWrapper>
        {passengers.map(
          (pax, index) =>
            pax.selected && (
              <ConfirmRequestAccordion
                data={pax}
                formData={formData}
                name={`${pax.firstName} ${pax.lastName}`}
                relation={
                  pax.relationshipStatus.includes("Child")
                    ? "Children"
                    : "Adult"
                }
                ind={index + 1}
                contactNum={extraFields?.contactNum}
              />
            )
        )}

        {guests.map((pax, index) => (
          <ConfirmRequestAccordion
            formData={formData}
            pdfNames={extraFields?.passportFileNames[index]}
            data={pax}
            name={`${pax.firstName}  ${pax.lastName}`}
            relation={pax.relationshipStatus}
            ind={index + 1}
            isGuestOr="guest"
          />
        ))}

        {formData.bookingComments && (
          <CommentWrapper>
            <TextFont
              fontColor={Colors.brandTwo}
              fontSize="1.375rem"
              fontWeight="700"
            >
              Special request
            </TextFont>
            <CommentMsg>{formData.bookingComments}</CommentMsg>
          </CommentWrapper>
        )}

        {/* <div>
          <NameRelationHeader name="Sarah Wasim" relation="Adult" index={2} />
          <TravellerDetailsGrid>
            <SectionHeaderAndContent
              heading="Passport Number"
              content="S0566545"
            />
            <SectionHeaderAndContent
              heading="Passport Expiry"
              content="16 Dec 2027"
            />
            <SectionHeaderAndContent
              heading="Payment Type"
              content="Company Paid"
            />
            <SectionHeaderAndContent heading="Travel Class" content="Economy" />
          </TravellerDetailsGrid>
        </div>
        <div>
          <NameRelationHeader name="Mostafa Farag" relation="Guest" index={2} />
          <TravellerDetailsGrid>
            <SectionHeaderAndContent
              heading="Passport Number"
              content="S0566545"
            />
            <SectionHeaderAndContent
              heading="Passport Expiry"
              content="16 Dec 2027"
            />
            <SectionHeaderAndContent
              heading="Payment Type"
              content="Self Paid"
            />
            <SectionHeaderAndContent heading="Travel Class" content="Economy" />
          </TravellerDetailsGrid>
        </div> */}
      </ColumnWrapper>
    </TravellerDetailsContainer>
  );
};

const TravellerDetailsContainer = styled.div`
  margin-top: 1.5rem;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.635rem;
`;
const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const CommentMsg = styled.div`
  font-weight: 500;
  font-size: 1rem;
  color: ${Colors.shark};
`;
export default ConfirmRequestTravellerDetailsContainer;
